import { createSagas } from "redux-box";
import swal from "sweetalert2";
import { call, put } from "redux-saga/effects";
import MiscApi from "@s/api/misc";
import { module as ui } from "@st/ui";

const errorHandler = err => {
  console.log(err);
  swal("Oops!", err.error_message, "error");
};
const getData = (res) => {
  let result = res.map((el) => {
    el.value = el.name;
    el.label = el.name;
    return el;
  });
  return result;
};
export default createSagas({
  REQUEST_ANALYTICS_STORY: function*() {
    try {
      const res = yield call(MiscApi.getAnalyticsStory);
      if (res.success) {
        swal("Success", res.result.message);
      }
    } catch (err) {
      errorHandler(err);
    }
  },
  REQUEST_PROJECTS_LIST: function*() {
    try {
      const res = yield call(MiscApi.getProjects);

      let result = getData(res.result);

      yield put({
        type: "SET_TIMEKIT_PROJECT_LIST",
        projectList: result,
      });
    } catch (err) {
      errorHandler(err);
    }
  },
  REQUEST_MAGIC_OTP: function*() {
    yield put({ type: "SET_MAGIC_OTP_LOADING", data: true });
    try {
      const res = yield call(MiscApi.getMagicOtp);

      // Backend response can vary; normalize to the OTP value.
      let otp =
        (res &&
          res.result &&
          res.result.otp !== undefined
          ? res.result.otp
          : null) ||
        (res &&
          res.result &&
          res.result.magic_otp !== undefined
          ? res.result.magic_otp
          : null) ||
        (res && res.otp !== undefined ? res.otp : null) ||
        (res && res.magic_otp !== undefined ? res.magic_otp : null);

      if (otp !== null) {
        yield put({ type: "SET_MAGIC_OTP", data: otp });
      }
    } catch (err) {
      errorHandler(err);
    } finally {
      yield put({ type: "SET_MAGIC_OTP_LOADING", data: false });
    }
  },
  UPDATE_MAGIC_OTP: function*({ data }) {
    yield put({ type: "SET_MAGIC_OTP_SAVING", data: true });
    try {
      const res = yield call(MiscApi.createOrUpdateMagicOtp, data);

      // Try to update the store with any OTP returned by the backend.
      let otp =
        (res &&
          res.result &&
          res.result.otp !== undefined
          ? res.result.otp
          : null) ||
        (res &&
          res.result &&
          res.result.magic_otp !== undefined
          ? res.result.magic_otp
          : null) ||
        (res && res.otp !== undefined ? res.otp : null) ||
        (res && res.magic_otp !== undefined ? res.magic_otp : null);

      // If backend doesn't return the updated OTP, fall back to the submitted value.
      if (otp === null && data && data.otp !== undefined) {
        otp = data.otp;
      }

      if (res && res.success) {
        swal("Done", (res.result && res.result.message) ? res.result.message : "Magic OTP updated", "success");
      } else if (otp !== null) {
        swal("Done", "Magic OTP updated", "success");
      }

      if (otp !== null) {
        yield put({ type: "SET_MAGIC_OTP", data: otp });
      }
    } catch (err) {
      errorHandler(err);
    } finally {
      yield put({ type: "SET_MAGIC_OTP_SAVING", data: false });
    }
  },
  REQUEST_SCHOOL_MAGIC_OTPS: function*({ school, offset }) {
    yield put({ type: "SET_SCHOOL_MAGIC_OTP_LOADING", data: true });
    try {
      const page = offset || 0;
      let query = `offset=${page}`;
      if (school) {
        query = query + `&school=${school}`;
      }
      const res = yield call(MiscApi.getSchoolGradeMagicOtps, query);
      if (res && res.success) {
        yield put({ type: "SET_SCHOOL_MAGIC_OTP_LIST", data: res.result || [] });
        yield put({
          type: "SET_SCHOOL_MAGIC_OTP_PAGE",
          data: {
            school: school || null,
            offset: page,
            count: res.count || 0,
            hasNext: !!res.has_next,
          },
        });
      } else {
        errorHandler(
          (res && res.error) || {
            error_message: (res && res.detail) || "Unable to load school magic OTPs",
          }
        );
      }
    } catch (err) {
      errorHandler(err);
    } finally {
      yield put({ type: "SET_SCHOOL_MAGIC_OTP_LOADING", data: false });
    }
  },
  REQUEST_SCHOOL_MAGIC_OTP_GRADES: function*({ school }) {
    yield put({ type: "SET_SCHOOL_MAGIC_OTP_GRADES", data: [] });
    if (!school) {
      return;
    }
    try {
      const res = yield call(MiscApi.getSchoolGrades, school);
      const grades = (res || []).map((el) => ({ value: el.grade, label: el.name }));
      yield put({ type: "SET_SCHOOL_MAGIC_OTP_GRADES", data: grades });
    } catch (err) {
      errorHandler(err);
    }
  },
  SAVE_SCHOOL_MAGIC_OTP: function*({ data }) {
    yield put({ type: "SET_SCHOOL_MAGIC_OTP_SAVING", data: true });
    try {
      const res = yield call(MiscApi.saveSchoolGradeMagicOtp, data);
      const count = res && res.length ? res.length : 0;
      swal("Done", `Magic OTP set for ${count} school grade record(s)`, "success");
      yield put({ type: "SET_SCHOOL_MAGIC_OTP_SAVED_AT", data: Date.now() });
      yield put({ type: "REQUEST_SCHOOL_MAGIC_OTPS", school: null, offset: 0 });
    } catch (err) {
      errorHandler(err);
    } finally {
      yield put({ type: "SET_SCHOOL_MAGIC_OTP_SAVING", data: false });
    }
  },
  UPDATE_SCHOOL_MAGIC_OTP: function*({ id, otp }) {
    yield put({ type: "SET_SCHOOL_MAGIC_OTP_SAVING", data: true });
    try {
      yield call(MiscApi.updateSchoolGradeMagicOtp, id, { otp });
      swal("Done", "Magic OTP updated", "success");
      yield put({ type: "SET_SCHOOL_MAGIC_OTP_SAVED_AT", data: Date.now() });
      const page = require("store").default.getState().misc.schoolMagicOtpPage;
      yield put({ type: "REQUEST_SCHOOL_MAGIC_OTPS", school: page.school, offset: page.offset });
    } catch (err) {
      errorHandler(err);
    } finally {
      yield put({ type: "SET_SCHOOL_MAGIC_OTP_SAVING", data: false });
    }
  },
  REMOVE_SCHOOL_MAGIC_OTP: function*({ id }) {
    yield put({ type: "SET_SCHOOL_MAGIC_OTP_SAVING", data: true });
    try {
      // deleteCall resolves with the whole response and never rejects on an API error
      const res = yield call(MiscApi.deleteSchoolGradeMagicOtp, id);
      if (res && res.success) {
        swal("Done", "Magic OTP deleted", "success");
        const miscState = require("store").default.getState().misc;
        const page = miscState.schoolMagicOtpPage;
        // step back when the last record of a page was deleted
        const offset =
          miscState.schoolMagicOtpList.length <= 1 && page.offset > 0
            ? page.offset - 1
            : page.offset;
        yield put({ type: "REQUEST_SCHOOL_MAGIC_OTPS", school: page.school, offset });
      } else {
        errorHandler(
          (res && res.error) || {
            error_message: (res && res.detail) || "Unable to delete the magic OTP",
          }
        );
      }
    } catch (err) {
      errorHandler(err);
    } finally {
      yield put({ type: "SET_SCHOOL_MAGIC_OTP_SAVING", data: false });
    }
  },
  CREATE_BULK_ASSIGNMENT : function*({data}){
    yield put({
      type: "SET_CREATING_ASSIGNMENT",
      data : true
    })
    try {
      let res = yield call(MiscApi.createBulkAssignment,data)
      console.log(res)
      if(res && res.id){
        yield put({
          type: "SET_ASSIGNMENT_CREATED",
          data : true
        })
      }
    } catch (err) {
      errorHandler(err);
    }
    finally{
      yield put({
        type: "SET_CREATING_ASSIGNMENT",
        data : false
      })
    }
  }
});
